import { Injectable } from '@angular/core';

@Injectable()
export class PaginationService {

  /**
   * Paging
   * getter setter
   */
  _appendedBeforePageIndex: boolean;
  get appendedBeforePageIndex() {

    return this._appendedBeforePageIndex;

  }
  set appendedBeforePageIndex(value: any) {

    this._appendedBeforePageIndex = value;

  }

  _appendedAfterPageIndex: boolean;
  get appendedAfterPageIndex() {

    return this._appendedAfterPageIndex;

  }

  set appendedAfterPageIndex(value: any) {

    this._appendedAfterPageIndex = value;

  }
  /**
   * END Paging
   * getter setter
   */

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/pagination/pagination.service.ts